import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import logoImage from "@/assets/logo.png";

const StickyHeader = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after scrolling past ~500px (hero area)
      setVisible(window.scrollY > 500);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-b border-border shadow-2xs animate-fade-in hidden md:block">
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex items-center justify-between">
        <img src={logoImage} alt="AILens" className="h-7 w-auto" />
        <Button onClick={scrollToTop} size="sm" className="font-semibold">
          Scan Now
        </Button>
      </div>
    </header>
  );
};

export default StickyHeader;
